import type { SVGProps } from 'react'
const LineChevronDownSmall = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M12 16.04c-.32 0-.64-.12-.885-.365L5.22 9.78l1.06-1.06L12 14.44l5.72-5.72 1.06 1.06-5.895 5.895a1.25 1.25 0 0 1-.885.365"
		/>
	</svg>
)
export { LineChevronDownSmall }
